module.exports = __webpack_public_path__ + "img/13.6aa26975.jpg";